import ChurnRiskIcon from '@assets/icons/churn-risk.svg';
import i18n from '@/utils/i18n';
import LostItemIcon from '@assets/icons/lost-item.svg';
import OverduePaymentIcon from '@assets/icons/overdue-payment.svg';
import React from 'react';
import { Badge, BadgeSize, BadgeVariant } from '@usepepper/ui/atoms/badge';
import { createStyles } from '@/contexts/theme-context';
import { HubCardType } from '@/types';
import { TYPOGRAPHY } from '@/styles';

export type AlertType =
  | HubCardType.ChurnRisk
  | HubCardType.LostItem
  | HubCardType.OverduePayment;

const alertDetails: Record<
  AlertType,
  {
    icon: React.ComponentType<{ stroke?: string }>;
    label: string;
  }
> = {
  [HubCardType.ChurnRisk]: {
    icon: ChurnRiskIcon,
    label: i18n.t('dsr_analytics.alerts.churn_risk'),
  },
  [HubCardType.LostItem]: {
    icon: LostItemIcon,
    label: i18n.t('dsr_analytics.alerts.lost_item'),
  },
  [HubCardType.OverduePayment]: {
    icon: OverduePaymentIcon,
    label: i18n.t('dsr_analytics.alerts.overdue_payment'),
  },
};

interface Props {
  alertType: AlertType;
}

export const AlertPill: React.FC<Props> = ({ alertType }) => {
  const [styles, theme] = useStyles();
  const { icon: Icon, label } = alertDetails[alertType];

  return (
    <Badge
      label={label}
      leftElement={<Icon stroke={theme.sk.color.icon.primary} />}
      size={BadgeSize.XSMALL}
      style={styles.container}
      textStyle={TYPOGRAPHY.h4}
      variant={BadgeVariant.BORDER}
    />
  );
};

const useStyles = createStyles(() => ({
  container: {
    paddingLeft: 4,
    paddingRight: 8,
    paddingVertical: 4,
  },
}));
